<template>
  <div>
    <v-card color="#EDF1F3">
      <v-layout align-center justify-start style="padding-left: 20px">
        <loading-component :value="loading"/>
        <v-form ref="form"
          ><img
            :src="api.GET_IMAGE(passenger.profile_image)"
            class="image"
            v-if="passenger"
          />
          <!-- @click="$refs.image.click()" -->
          <!-- <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
          /> -->
        </v-form>

        <v-flex xs3>
          <div class="headline">
            {{ this.passenger.full_name }}
          </div>
          <div style="color: #8599a3">{{ this.passenger.email }}</div>
          <div style="color: #8599a3; margin-top: 6px">
            {{ moment(this.passenger.birthday).format("DD MMM YYYY") }}
          </div>
        </v-flex>
   
        <v-flex xs2>
          <v-switch
            v-if="this.$store.state.user.roles[0].name == 'Super Admin' && this.passenger.passenger_type != 'NORMAL'"
            v-model="disabledSwitch"
            :label="$t('customers.passengerProfile.disable')"
            @change="changeDisabledStatus"
            color="blue"
          ></v-switch>  
        </v-flex>
        
        <v-flex xs2>
          <v-switch
            v-if="this.$store.state.user.roles[0].name  != 'Goverment'"
            v-model="vipSwitch"
            label="VIP"
            @change="changeVIPStatus"
            color="blue"
          ></v-switch>  
        </v-flex>
      </v-layout>
    </v-card>

    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <!-- <v-tab :key="1" ripple active-class="tab"> Info </v-tab> -->

      <v-tab-item>
        <v-card
          height="100%"
          style="height: 100%; position: absolute; width: 100%"
        >
          <v-layout align-center>
            <v-flex xs6 style="height: 100%; margin-left: 100px">
              <v-card-title primary-title>
                <v-flex xs12 style="margin-bottom: 25px"
                  ><div class="headline">{{ $t("customers.passengerProfile.information") }}</div></v-flex
                >
                <table>
                  <tr>
                    <th>{{ $t("customers.passengerProfile.id") }}</th>
                    <td>
                      <span>{{ this.passenger.id }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.passengerProfile.fullName") }}</th>
                    <td>
                      <v-text-field
                        v-model="editHolder.full_name_value"
                        style="float: left"
                        :label="$t('customers.passengerProfile.fullName')"
                        :disabled="!this.editHolder.full_name"
                        :rules="[(val) => !!val || $t('customers.passengerProfile.required')]"
                      >
                      </v-text-field>
                      <button
                        @click="editHolder.full_name = true"
                        v-if="!this.editHolder.full_name"
                      >
                        <v-icon>edit</v-icon>
                      </button>
                      <button
                        @click="
                          editHolder.full_name = false;
                          editHolder.full_name_value = passenger.full_name;
                        "
                        v-if="this.editHolder.full_name"
                      >
                        <v-icon>close</v-icon>
                      </button>
                      <button
                        @click="editHolder.full_name = false"
                        v-if="this.editHolder.full_name"
                      >
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.passengerProfile.username") }}</th>
                    <td>
                      <v-text-field
                        v-model="editHolder.username_value"
                        style="float: left"
                        :label="$t('customers.passengerProfile.username')"
                        :disabled="!this.editHolder.username"
                        :rules="[(val) => !!val || $t('customers.passengerProfile.required')]"
                      >
                      </v-text-field>
                      <button
                        @click="editHolder.username = true"
                        v-if="!this.editHolder.username"
                      >
                        <v-icon>edit</v-icon>
                      </button>
                      <button
                        @click="
                          editHolder.username = false;
                          editHolder.username_value = passenger.username;
                        "
                        v-if="this.editHolder.username"
                      >
                        <v-icon>close</v-icon>
                      </button>
                      <button
                        @click="editHolder.username = false"
                        v-if="this.editHolder.username"
                      >
                        <v-icon>check</v-icon>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t("customers.passengerProfile.creationDate") }}</th>
                    <td>
                      <span>
                        {{
                          moment(this.passenger.created_at).format(
                            "DD MMM YYYY [at] HH:mm a"
                          )
                        }}
                      </span>
                    </td>
                  </tr>
                </table>
              </v-card-title>
            </v-flex>
          </v-layout>
          <v-btn
            @click="save"
            :loading="loading"
            style="float: right"
            color="primary"
            :disabled="disableSaveButton"
            >{{ $t("common.save") }}</v-btn
          >
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "PassengerProfile",
  title() {
    return this.$t("customers.passengerProfile.title");
  },
  components:{
    LoadingComponent,
  },

  data() {
    return {
      passenger: null,
      loading: true,
      disabledSwitch:false,
      vipSwitch:false,
      dialog: false,
      active: 1,
      editHolder: {
        full_name: false,
        full_name_value: "",
        username: false,
        username_value: "",
      },
    };
  },
  mounted() {
    this.axios.get(`passenger/${this.$route.params.id}`).then(({ data }) => {
      this.passenger = data.data;
      this.editHolder.full_name_value = data.data.full_name;
      this.editHolder.username_value = data.data.username;
      this.loading = false;
      this.disabledSwitch = data.data.disabled_at != null;
      this.vipSwitch = data.data.vip;
      console.log("passegers");
      console.log(this.passenger);
    });
  },
  methods: {
    changeDisabledStatus(value) {
      let disabled = value ? 1 : 0;
      let id = this.passenger.id;
      this.loading = true;
      this.axios
        .put('passenger/'+id+'/change_disabled_at_value', { disabled })
        .then((res) => {
          this.loading = false;
          window.getApp.$emit("SHOW_TOAST", value ? this.$t("customers.passengerProfile.accountDisabled") : this.$t("customers.passengerProfile.accountEnabled"), "green");
        })
        .catch((err) => {
          this.loading = false;
          console.log("error");
        });
    },
    changeVIPStatus(value) {
      let vip = value ? 1 : 0;
      let id = this.passenger.id;
      this.loading = true;
      this.axios
        .put('passenger/'+id+'/change_vip_value', { vip })
        .then((res) => {
          this.loading = false;
          window.getApp.$emit("SHOW_TOAST", this.$t("customers.passengerProfile.doneSuccessfully"), "green");
        })
        .catch((err) => {
          this.loading = false;
          console.log("error");
        });
    },

    openImage(value) {
      // console.log(value);
      window.open(this.api.GET_IMAGE(value.path), "_blank");
    },
    save() {
      let updatedInfo = {};

      if (
        this.editHolder.full_name_value &&
        this.editHolder.full_name_value != this.passenger.full_name
      )
        updatedInfo["full_name"] = this.editHolder.full_name_value;
      else delete updatedInfo["full_name"];

      if (
        this.editHolder.username_value &&
        this.editHolder.username_value != this.passenger.username
      )
        updatedInfo["username"] = this.editHolder.username_value;
      else delete updatedInfo["username"];

      if (
        this.editHolder.full_name_value == "" ||
        this.editHolder.username_value == ""
      )
        return;

      if (
        this.editHolder.username_value == this.passenger.username &&
        this.editHolder.full_name_value == this.passenger.full_name
      )
        return;

      this.axios
        .put(`passenger/${this.$route.params.id}`, updatedInfo)
        .then(() => {
          this.passenger.username = this.editHolder.username_value;
          this.passenger.full_name = this.editHolder.full_name_value;
          window.getApp.$emit("SHOW_TOAST", this.$t("customers.passengerProfile.saved"), "green");
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", [
            "bottom",
            "left",
          ]);
        });
    },
  },
  computed: {
    today() {
      return moment().format("YYYY-MM-DD");
    },
    disableSaveButton() {
      return (
        this.editHolder.username_value == this.passenger.username &&
        this.editHolder.full_name_value == this.passenger.full_name
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  background-color: #ffffff !important;
}
.docs:hover {
  cursor: pointer;
}
.star {
  color: #f3c220;
}
.image {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin-right: 17px;
  margin-top: 10px;
}
.image:hover {
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  cursor: pointer;
}
.tab {
  color: #e21024 !important;
}
.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

.passengers-list {
  width: 100%;
  margin-left: 90px;
  z-index: 7;
  max-height: 100px;
  min-height: 100px;
  float: left;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.passenger {
  width: max-content;
  float: left;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  cursor: pointer;

  img {
    height: 32px;
    width: 32px;
    float: left;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }
}

.car {
  color: #7e939c;
}
.open {
  margin-bottom: 15px;
  margin-left: 35px;
}
.constraints.v-label {
  font-size: xx-large !important;
}

table {
  max-width: 500px;
  width: 500px;
  tr {
    th,
    td {
      padding: 0 12px;
      text-align: left;

      span {
        padding: 16px 0;
        float: left;
      }
    }
    th {
      padding-left: 0;
    }
    td {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      gap: 14px;
      max-width: 350px;
      width: 350px;
    }
  }
}
</style>
